// Species picker: photo tiles on the canopy bar (design pass, docs/design).
// Dimming during flight and the breathing attract hint are CSS, keyed on
// the app root's data-state. A tile press is the only input to the insect
// state machine.
import { t, onLanguageChange, getLanguage } from '../i18n/index.js';
import { el } from '../debug/controls.js';
import { ICON_BUTTERFLY } from './icons.js';

export function createPicker(app, { species, onPick }) {
  const root = el('div', { class: 'picker', role: 'group' });
  const tiles = new Map();

  for (const s of species) {
    const photo = el('img', { class: 'tile__photo', alt: '', draggable: 'false' });
    const fallback = el('div', { class: 'tile__photo tile__photo--placeholder' });
    fallback.style.background = s.placeholderPhoto;
    fallback.innerHTML = `<div class="tile__placeholder-icon">${ICON_BUTTERFLY}</div>`;
    fallback.hidden = true;
    photo.addEventListener('error', () => {
      photo.hidden = true;
      fallback.hidden = false;
    });
    photo.src = s.photo;
    const tile = el('button', { class: 'tile', type: 'button', 'data-species': s.id, 'aria-pressed': 'false' }, [
      photo,
      fallback,
      el('div', { class: 'tile__scrim' }),
    ]);
    tile.addEventListener('pointerdown', () => tile.classList.add('is-pressed'));
    for (const type of ['pointerup', 'pointercancel', 'pointerleave']) {
      tile.addEventListener(type, () => tile.classList.remove('is-pressed'));
    }
    tile.addEventListener('click', () => onPick(s.id));
    tiles.set(s.id, tile);
    root.append(tile);
  }

  const render = () => {
    root.setAttribute('aria-label', t('picker.label'));
    for (const s of species) {
      tiles.get(s.id).setAttribute('aria-label', s.names[getLanguage()]?.common ?? s.names.en.common);
    }
  };
  render();
  onLanguageChange(render);

  app.append(root);
  return {
    root,
    setSelected(speciesId) {
      for (const [id, tile] of tiles) {
        const on = id === speciesId;
        tile.classList.toggle('is-selected', on);
        tile.setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    },
  };
}
